import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var EbookIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M24.0101 5.12C20.1039 5.12 16.2855 6.27833 13.0377 8.44849C9.7898 10.6186 7.25833 13.7032 5.7635 17.312C4.26867 20.9209 3.87742 24.8919 4.63947 28.723C5.40153 32.5541 7.28266 36.0732 10.0447 38.8353C12.8068 41.5974 16.3259 43.4784 20.1571 44.2405C23.9882 45.0025 27.9593 44.6114 31.5682 43.1166C35.177 41.6217 38.2616 39.0904 40.4317 35.8425C42.6019 32.5947 43.7601 28.7762 43.7601 24.87C43.7614 22.276 43.2514 19.7072 42.2593 17.3104C41.2673 14.9137 39.8126 12.736 37.9783 10.9017C36.1441 9.06752 33.9664 7.61279 31.5697 6.62073C29.1729 5.62867 26.6041 5.11868 24.0101 5.12ZM35.6002 26H17.41C17.82 30 20.6301 32.46 24.7501 32.46C27.1902 32.4385 29.5593 31.636 31.5101 30.17L34.1102 33.73C31.3733 35.9824 27.9243 37.1876 24.3802 37.13C17.3802 37.13 11.64 32.68 11.64 24.46C11.64 16.46 17.1201 11.46 24.0301 11.46C31.2401 11.46 35.72 16.82 35.72 23.85C35.7189 24.555 35.679 25.2594 35.6002 25.96V26ZM24.0201 16.17C22.3853 16.144 20.8017 16.7398 19.5894 17.8369C18.3772 18.9341 17.6267 20.4507 17.4901 22.08H30.1102C29.8202 18.86 27.7601 16.17 24.0201 16.17Z"
  }));
});
EbookIcon.displayName = 'EbookIcon';
EbookIcon.defaultProps = {
  'aria-label': 'Ebook'
};
export default EbookIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/EbookIcon/index.js
// module id = 1832
// module chunks = 12